import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Box, Typography, Link,
} from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import useApplicationStyle from '../../styles/ApplicationStyles.jsx';

const Application = ({
  title = '', demos = [], link = '', description = '', stack = [], theme, isMobile,
}) => {
  const {
    root,
    applicationContainer,
    applicationContainerDark,
    applicationContainerMobile,
    applicationContainerMobileDark,
    appTitle,
    demoContainer,
    demo,
    descriptionContainer,
    descriptionContainerMobile,
    repo,
  } = useApplicationStyle();
  const showCarousel = demos.length >= 3;
  const [activeIdx, setActiveIdx] = useState(0);
  const [display, setDisplay] = useState(demos[0]);
  let applicationClass;

  if (!isMobile) {
    if (theme === 'light') {
      applicationClass = applicationContainer;
    } else {
      applicationClass = `${applicationContainer} ${applicationContainerDark}`;
    }
  } else if (theme === 'light') {
    applicationClass = `${applicationContainer} ${applicationContainerMobile}`;
  } else {
    applicationClass = `${applicationContainer} ${applicationContainerMobile} ${applicationContainerMobileDark}`;
  }

  const handleRight = () => {
    if (activeIdx === demos.length - 1) {
      setActiveIdx(0);
    } else {
      setActiveIdx(activeIdx + 1);
    }
  };

  const handleLeft = () => {
    if (activeIdx === 0) {
      setActiveIdx(demos.length - 1);
    } else {
      setActiveIdx(activeIdx - 1);
    }
  };

  useEffect(() => {
    if (showCarousel) {
      const ToDisplay = demos[activeIdx];
      setDisplay(ToDisplay);
    }
  }, [activeIdx, showCarousel]);

  return (
    <Box className={root}>
      <Box className={applicationClass}>
        <Box className={demoContainer}>
          {showCarousel && <ArrowLeftIcon onClick={handleLeft} style={{ cursor: 'pointer' }} />}
          {!showCarousel && demos.map(
            (img, idx) => <img key={`${title}-${idx}`} src={img} alt='' className={demo} />,
          )}
          {showCarousel && <img src={display} alt='' className={demo} />}
          {showCarousel && <ArrowRightIcon onClick={handleRight} style={{ cursor: 'pointer' }} />}
        </Box>
        <Box className={isMobile ? `${descriptionContainer} ${descriptionContainerMobile}` : descriptionContainer}>
          <Typography className={appTitle}>{title}</Typography>
          <Typography>{description}</Typography>
          <Typography><em>Tech Stack: {stack.join(', ')}</em></Typography>

          <Link href={link} target='_blank' color='inherit' className={repo}>
            <GitHubIcon fontSize='large' />
          </Link>

        </Box>
      </Box>
    </Box>
  );
};

Application.propTypes = {
  title: PropTypes.string,
  demos: PropTypes.array,
  link: PropTypes.string,
  description: PropTypes.string,
  stack: PropTypes.array,
  theme: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default Application;
